// Copyright (c) Move Closer 2022.

import { DocumentNode } from 'graphql'
import { AnyObject, Headers, IConfiguration, IResponse, MetaPayload } from '@movecloser/front-core'
import { TypedDocumentNode } from '@graphql-typed-document-node/core'

import { MutationOptions, QueryOptions } from './driver.contracts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const GraphQlConnectorType = Symbol.for('IGraphQL')

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export interface GraphQLMiddleware {
  afterCall?: (definition: QueryDefinition, response: IResponse) => void
  beforeCall?: (
    definition: QueryDefinition,
    headers: Headers,
    query: MutationOptions | QueryOptions
  ) => GraphQLMiddlewareBeforeResult
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export type GraphQLMiddlewareBeforeResult = GraphQLMiddlewareBeforeReturn | Promise<GraphQLMiddlewareBeforeReturn>

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
interface GraphQLMiddlewareBeforeReturn {
  headers: Headers
  query: MutationOptions | QueryOptions
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface IGraphQL {
  call (query: string, variables: AnyObject, headers?: Headers): Promise<IResponse>
  useMiddlewares (list: GraphQLMiddleware[]): void
  useQueries (queries: QueryRegistry): void
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export interface QueryDefinition {
  type: QueryDefinitionType
  query: DocumentNode | TypedDocumentNode
  meta: MetaPayload
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export type QueryRegistry = Record<string, QueryDefinition>

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export type QueryRegistryFactory = (config: IConfiguration) => Record<string, QueryDefinition>

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export type QueryDefinitionType = 'mutation' | 'query'
